export const SHIPPING_LABELS = {
  shipToName: 'requestUpdate.shippingSection.shipToNameLabel',
  address1: 'requestUpdate.shippingSection.address1',
  address2: 'requestUpdate.shippingSection.address2',
  address3: 'requestUpdate.shippingSection.address3',
  city: 'common.labels.city',
  stateCode: 'common.labels.stateProvince',
  postalCode: 'common.labels.zip',
  notes: 'common.labels.notes'
};

export const RESCHEDULE_LABELS = {
  reason: 'requestUpdate.rescheduleTCModal.reasonLabel',
  dates: 'requestUpdate.rescheduleTCModal.rescheduleDatesLabel'
};

export const REASON_OPTIONS = {
  inclementWeather: 'Inclement weather',
  other: 'Other',
};